export const jobsFotos = [
    {
      id: 0,
      title: "Bodas",
      description: "Bodas",
      src: "https://imagizer.imageshack.com/v2/1024x768q70/924/sWxUuX.jpg",
      link: "/bodas"
    },
    {
      id: 1,
      title: "Quinces",
      description: "Fiestas de 15",
      src: "https://imagizer.imageshack.com/v2/1024x768q70/922/qyiHkZ.jpg",
      link: "/quinces",
    },
    {
      id: 2,
      title: "Bautismos",
      description: "Bautismos",
      src: "https://imagizer.imageshack.com/v2/1024x768q70/922/Q8S7IZ.jpg",
      link: "/bautismos",
    },
    {
      id: 3,
      title: "Comuniones",
      description: "Comuniones",
      src: "https://imagizer.imageshack.com/v2/1024x768q70/923/acrIig.jpg",
      link: "/comuniones",
    },
    {
      id: 4,
      title: "Aniversarios",
      description: "Aniversarios",
      src: "https://imagizer.imageshack.com/v2/1024x768q70/924/HSRU1K.jpg",
      link: "/aniversarios",
    },
    {
      id: 5,
      title: "Infantiles",
      description: "Infantiles",
      src: "https://imagizer.imageshack.com/v2/1024x768q70/924/aYpc1K.jpg",
      link: "/infantiles",
    },
    {
      id: 6,
      title: "Books",
      description: "Books",
      src: "https://imagizer.imageshack.com/v2/1024x768q70/923/217hQX.jpg",
      link: "/books",
    }
]